'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parseZIndex = exports.parseZIndex = function parseZIndex(zIndex) {
    var auto = zIndex === 'auto';
    return {
        auto: auto,
        order: auto ? 0 : parseInt(zIndex, 10)
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/html2canvas/dist/npm/parsing/zIndex.js
// module id = 1528
// module chunks = 1